import React from "react";
import { formatValue, TrendBadge } from "../widgetFormat";

const CATEGORY_TONES = {
  financial: { bg: "#0E5FFF", fg: "#ffffff", accent: "FINANCIERO" },
  operational: { bg: "#0a0a0b", fg: "#ffffff", accent: "OPERATIVO" },
  sales: { bg: "#1F8A3B", fg: "#ffffff", accent: "VENTAS" },
  custom: { bg: "#7C3AED", fg: "#ffffff", accent: "CUSTOM" },
};

/**
 * KPI widget — big value + optional trend badge. Reused by every widget
 * whose `type === "kpi"`.
 */
export default function KpiWidget({ definition, payload, onDrilldown }) {
  const tone = CATEGORY_TONES[definition.category] || CATEGORY_TONES.custom;
  const data = payload?.data || {};
  const value = data.value;
  const format = data.format || "int";
  const trendPct = data.trend_pct ?? null;
  const trendLabel = data.trend_label ?? null;
  const clickable = !!payload?.drilldown;

  return (
    <button
      type="button"
      onClick={() => clickable && onDrilldown?.(definition, payload)}
      disabled={!clickable}
      data-testid={`widget-kpi-${definition.id}`}
      className={`relative overflow-hidden p-5 sm:p-6 flex flex-col justify-between min-h-[160px] w-full text-left transition-transform ${
        clickable ? "hover:scale-[1.01] cursor-pointer" : "cursor-default"
      }`}
      style={{ background: tone.bg, color: tone.fg }}
    >
      <div
        className="absolute inset-0 opacity-[0.08] grid-bg pointer-events-none"
        style={{ backgroundSize: "24px 24px" }}
        aria-hidden
      />
      <div className="relative">
        <div className="font-mono-tech text-[0.6rem] font-bold tracking-[0.25em] opacity-80">
          {tone.accent}
        </div>
        <div className="font-display text-sm font-bold tracking-tight mt-1 opacity-95 line-clamp-2">
          {definition.title}
        </div>
      </div>
      <div className="relative">
        <div className="font-mono-tech font-black leading-none tabular-nums text-4xl sm:text-5xl">
          {formatValue(value, format)}
        </div>
        <div className="mt-2">
          <TrendBadge pct={trendPct} label={trendLabel} />
        </div>
      </div>
      {clickable && (
        <div className="absolute top-3 right-3 font-mono-tech text-[0.65rem] font-bold tracking-wider opacity-60">
          ↗
        </div>
      )}
    </button>
  );
}
